export default __webpack_public_path__ + "static/media/mohamed.1a212f21.jpeg";